



































































import { Vue, Component, Watch } from "@/shared/vuepack";
import * as RouteNames from "@/employee/route-names";
import { BankCustodian } from "@/admin/types";
import UploadForm from "@/employee/components/secure-document-upload/UploadForm.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useThemeStore } from "@/shared/store/theme";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useSecureDocumentUploadStore } from "@/employee/store/secureDocumentUpload";
import { FetchState, FileUploadCategory, FileUploadErrorModel } from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    UploadForm,
    GenericLoadingSpinner
  }
})
export default class SecureDocumentUploadComponent extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  themeStore = useThemeStore();
  secureDocumentUploadStore = useSecureDocumentUploadStore();
  userBankAccountStore = useUserBankAccountStore();
  hsabAccountsStore = useHsabAccountsStore();

  category = null;
  categoryMetadata = null;
  isUploadSuccessful = false;
  isSubmitting = false;
  files = [];
  fileUploadErrors: FileUploadErrorModel[] = [];

  created () {
    this.secureDocumentUploadStore.loadCategories();
  }

  get isLoading () {
    return this.isSubmitting || !this.secureDocumentUploadStore.isLoaded || !this.isBankAccountLoaded;
  }

  @Watch("categories", { immediate: true })
  onCategoryLoad () {
    this.categoryMetadata = this.secureDocumentUploadStore.categories.find(x => x.category === this.category);
  }

  get categories () {
      return this.secureDocumentUploadStore.categories;
  }

  get isBankAccountLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded;
  }

  mounted (): void {
    this.userBankAccountStore.loadBankAccountState();
  }

  beforeUpdate (): void {
    if (this.secureDocumentUploadStore.categories.length === 1) {
      this.category = this.secureDocumentUploadStore.categories[0].category;
      this.onCategoryChange(this.category);
    }
  }

 get isCategorySelected () {
    return this.category !== null;
 }

  get isIdentityVerification () {
    return this.category === FileUploadCategory.IdentityVerification;
  }

  get isFormsUpload () {
    return this.category === FileUploadCategory.Forms;
  }

  get shouldDisplayUploadReceiptsWarning () {
    return this.featureFlagStore.flags.bend18761AddDeepLinkToResourcesPages &&
           this.hsabAccountsStore.userHasActiveNotionalAccounts;
  }

  get categoryOptions () {
    return this.secureDocumentUploadStore.categories.map(category => ({
        text: category.displayName,
        value: category.category
      }));
  }

  get invalid (): boolean {
    return this.category === FileUploadCategory.Unknown || this.files.length <= 0;
  }

  onFilesAdd (files: File[]) {
    this.files = files;
  }

  onCategoryChange (value) {
    this.categoryMetadata = this.secureDocumentUploadStore.categories.find(x => x.category === value);
  }

  onClose () {
    this.reset();
  }

  submit (): void {
    if (this.invalid) {
      return;
    }
    this.isSubmitting = true;

    this.secureDocumentUploadStore.upload(
      { category: this.category, accountNumber: this.userBankAccountStore.accountNumber, files: this.files })
      .then(response => {
        this.reset();
        if (response && response.success === false) {
          this.fileUploadErrors = response.errors;
          return;
        }
        this.isUploadSuccessful = true;
        this.resetFileUploadErrors();
        this.scrollToTop();
      })
      .catch(_ => {
        this.reset();
      });
  }

  scrollToTop () {
    window.scrollTo({
      behavior: "smooth",
      left: 0,
      top: 0
    });
  }

  reset () {
    this.isSubmitting = false;
    this.isUploadSuccessful = false;
    this.files = [];
  }

  resetFileUploadErrors () {
    this.fileUploadErrors = [];
  }
}

